<template>
    <div class="app">
        <div class="title">
            <div class="dis">
                <div class="title_text">订单管理</div>
            </div>
        </div>

        <div class="head_box">
            <div class="ipt_list">
                <div class="box1">
                    <div class="dis">
                        <div class="first_title">订单ID</div>
                        <el-input v-model="orderId" placeholder="请输入" clearable></el-input>
                    </div>
                </div>
                <div class="box1">
                    <div class="dis">
                        <div class="other_title">项目名称</div>
                        <el-input v-model="projectName" placeholder="请输入" clearable></el-input>
                    </div>
                </div>
                <div class="box1">
                    <div class="dis">
                        <div class="other_title">客户名称</div>
                        <el-select v-model="customerName" placeholder="请选择" filterable clearable
                            @change="onCustomerChange">
                            <el-option v-for="item in customerList" :key="item.customerName" :label="item.customerName"
                                :value="item.customerName">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="box1">

                    <div class="dis">
                        <div class="other_title">负责人</div>
                        <el-select v-model="value4" placeholder="请选择" filterable clearable>
                            <el-option v-for="item in PersonList" :key="item.personName" :label="item.personName"
                                :value="item.personName">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="box1">
                    <div class="dis">
                        <el-button class="search_btn dis_center" type="primary" @click="rold()">
                            <div class="dis_center">
                                <div>搜索</div>
                            </div>
                        </el-button>
                        <!-- <el-button class="Add_btn dis_center" type="primary" @click="add_btn(0)">
                            <div class="dis_center">
                                <img class="img11" src="../../assets/12.png" alt="" />
                                <div>新增</div>
                            </div>
                        </el-button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="table_pad">
            <div class="table">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
                    @selection-change="handleSelectionChange" :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ textAlign: 'center' }">
                    <el-table-column type="index" label="序号" width="65">
                    </el-table-column>
                    <el-table-column prop="orderNo" label="订单ID" min-width="15%">
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" min-width="10%">
                        <template slot-scope="scope">
                            <div style="color: orange;">{{ scope.row.amount / 100 }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contractName" label="项目名称" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="customerName" label="客户名称" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="responsiblePerson" label="负责人" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="userId" label="支付用户ID" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="address" label="操作" min-width="15%">
                        <template slot-scope="scope">
                            <div class="dis_center table_btn">
                                <div class="dis" @click="jump(scope.row)">
                                    <div>查看项目</div>
                                </div>
                                <!-- <div class="dis" @click="add_btn(1, scope.row)">
                                    <img src="../../assets/17.png" class="img17" alt="" />
                                    <div>修改</div>
                                </div> -->
                                <!-- <div class="dis table_delete" @click="delete_btn(0, scope.row.id)">
                                    <img src="../../assets/18.png" class="img17" alt="" />
                                    <div>删除</div>
                                </div> -->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page_box">
                <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :current-page.sync="pageNumber" :total="total">
                </el-pagination>
            </div>
        </div>

        <div class="shardow dis_center" v-if="show_shardow">
            <div class="show_box">
                <div class="show_title dis_center">
                    <div v-if="show_type == 0">新增</div>
                    <div v-else>修改</div>
                    <img src="../../assets/19.png" class="img19" alt="" @click="close" />
                </div>
                <div class="show_detail" style="height: 250rem;">
                    <div class="dis_center shardow_ipt_box">
                        <div class="shardow_title">所属学校：</div>
                        <el-select class="shardow_ipt" v-model="info.schoolId" placeholder="请选择学校"
                            @change="onModalSchoolChange">
                            <el-option v-for="item in schoolList" :key="item.id" :label="item.schoolName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="dis_center shardow_ipt_box">
                        <div class="shardow_title">所属年级：</div>
                        <el-select class="shardow_ipt" v-model="info.gradeId" placeholder="请选择年级"
                            :disabled="!info.schoolId">
                            <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="dis_center shardow_ipt_box">
                        <div class="shardow_title">班级名称：</div>
                        <el-input class="shardow_ipt" v-model="info.className" placeholder="请输入班级名称"></el-input>
                    </div>
                </div>
                <div class="shardow_btn dis_center">
                    <div class="shardow_btn1 dis_center" @click="close">取消</div>
                    <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
                        确定
                    </button>
                </div>
            </div>
        </div>

        <div class="shardow dis_center" v-if="show_delete">
            <div class="show_box">
                <div class="show_title dis_between">
                    <div>删除确认</div>
                    <img src="../../assets/19.png" class="img19" alt="" @click="close" />
                </div>
                <div class="dis_center shardow_deleteInfo">
                    <img src="../../assets/20.png" class="img20" alt="" />
                    <div>确定要删除所选择的班级吗？</div>
                </div>
                <div class="shardow_btn dis_center">
                    <div class="shardow_btn1 dis_center" @click="close">取消</div>
                    <div class="shardow_btn2 dis_center" @click="remove">确定</div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import {
    img_url,
    getProjectOrderList,
    getProjectOrderMePage,
    editProjectOrder,
    removeProjectOrder,
    getProjectOrderDetail,
    addProjectOrder,
    getCustomerList, getProjectPersonList
} from "../js/api";

export default {
    data() {
        return {
            img_url: "",
            disabled_save: false,
            userInfo: {},
            info: {
                id: "",
                orderNo: "",
                orderSource: "",
                orderSourceStr: "",
                payRecordId: "",
                payStatus: "",
                payWay: "",
                payableFee: "",
                rebateFee: "",
                recordType: "",
                remark: "",
                sourceId: "",
                status: "",
                totalFee: "",
                updateTime: "",
                userId: "",
                userName: "",
                userPhone: "",
                amount: "",
                createTime: "",
            },
            multipleSelection: [],
            chooseId: "",
            show_type: 0,
            show_shardow: false,
            show_delete: false,
            delete_type: 0,
            pageNumber: 1,
            pageSize: 10,
            total: 0,
            input: "",
            // 搜索条件
            orderId: "",
            projectName: "",
            customerName: "",
            value4: "",
            // 选择器数据
            orderStatusList: [],
            tableData: [],
            customerList: [],
            PersonList: [],
            multipleSelection: [],
        };
    },
    components: {},
    created() {
        let that = this;
        that.img_url = img_url;
        that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        that.initOrderStatusList(); that.getCustomerList();
        that.getProjectPersonList()
        that.ajaxload();
    },
    methods: {
        jump(e) {
            let that = this;
            that.$router.push('./ProjectInformation?id=' + e.contractId)
        },
        // 页面跳转相关方法
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.ajaxload();
        },
        close() {
            this.show_shardow = false;
            this.show_delete = false;
        },
        // 搜索区域客户变化
        onCustomerChange(customerId) {
            let that = this;

        },
        // 初始化订单状态列表
        initOrderStatusList() {
            this.orderStatusList = [
                { value: '', label: '全部' },
                { value: '0', label: '待支付' },
                { value: '1', label: '已支付' },
                { value: '2', label: '已取消' },
                { value: '3', label: '已完成' }
            ];
        },

        rold() {
            let that = this;
            that.pageNumber = 1;
            that.ajaxload();
        },
        ajaxload() {
            let that = this;
            let json = {
                pageReq: {
                    pageNumber: that.pageNumber,
                    pageSize: that.pageSize,
                }
            };
            json.entityParam = {
                payStatus: 1
            };

            // 添加搜索条件
            if (that.orderId) {
                json.entityParam.orderNo = that.orderId;
            }
            if (that.projectName || that.value4) {
                json.keyWords = {}
            }
            if (that.projectName) {
                json.keyWords.contractName = that.projectName;
            }
            if (that.value4) {
                json.keyWords.responsiblePerson = that.value4
            }
            if (that.customerName) {
                json.entityParam.customerName = that.customerName;
            }

            getProjectOrderMePage(json).then((res) => {
                console.log('订单列表:', res);
                if (res.code == 200) {
                    let data = res.data.records;
                    that.tableData = data;
                    that.total = Number(res.data.total || 0);
                } else {
                    that.$message.error(res.message || '获取订单列表失败');
                }
            }).catch(err => {
                console.error('获取订单列表失败:', err);
                that.$message.error('获取订单列表失败');
            });
        },
        // 获取客户列表
        getCustomerList() {
            let that = this;
            getCustomerList({}).then((res) => {
                if (res.code == 200) {
                    let data = res.data;
                    for (let i in data) {
                        data[i].id = Number(data[i].id)
                    }
                    that.customerList = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 获取人员列表
        getProjectPersonList() {
            let that = this;
            getProjectPersonList({}).then((res) => {
                if (res.code == 200) {
                    let data = res.data;
                    for (let i in data) {
                        data[i].id = Number(data[i].id)
                    }
                    that.PersonList = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        save() {
            let that = this;
            that.disabled_save = true;
            let json = that.info;

            // 验证必填字段
            if (!json.schoolId) {
                that.$message({
                    message: "请选择所属学校",
                    type: "warning",
                    duration: 1000,
                });
                that.disabled_save = false;
                return;
            }
            if (!json.gradeId) {
                that.$message({
                    message: "请选择所属年级",
                    type: "warning",
                    duration: 1000,
                });
                that.disabled_save = false;
                return;
            }
            if (!json.className || json.className.trim() === '') {
                that.$message({
                    message: "请输入班级名称",
                    type: "warning",
                    duration: 1000,
                });
                that.disabled_save = false;
                return;
            }

            editClass(json).then((res) => {
                that.disabled_save = false;
                console.log('保存班级:', res);
                if (res.code == 200) {
                    that.close();
                    that.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    that.ajaxload();
                } else {
                    that.$message.error(res.message || '保存失败');
                }
            }).catch(err => {
                that.disabled_save = false;
                console.error('保存班级失败:', err);
                that.$message.error('保存失败');
            });
        },
        remove() {
            let that = this;
            let json = {
                id: that.chooseId
            };
            removeClass({ params: json }).then((res) => {
                console.log('删除班级:', res);
                if (res.code == 200) {
                    that.close();
                    that.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    that.ajaxload();
                } else {
                    that.$message.error(res.message || '删除失败');
                    that.close();
                    that.ajaxload();
                }
            }).catch(err => {
                console.error('删除班级失败:', err);
                that.$message.error('删除失败');
                that.close();
                that.ajaxload();
            });
        },
        delete_btn(e, w) {
            let that = this;
            if (e == 0) {
                that.chooseId = w;
            } else if (e == 1) {
                if (that.multipleSelection.length == 0) {
                    that.$message({
                        message: "请选择班级",
                        type: "warning",
                    });
                    return;
                }
            }
            that.delete_type = e;
            that.show_delete = true;
        },
        add_btn(e, w) {
            let that = this;
            if (e == 0) {
                // 新增班级
                that.info = {
                    id: "",
                    schoolId: "",
                    gradeId: "",
                    className: "",
                    classCount: "",
                };
                // 清空年级列表
                that.gradeList = [];
            } else {
                // 修改班级
                that.info = JSON.parse(JSON.stringify(w));
                // 如果有学校ID，加载对应的年级列表
                if (that.info.schoolId) {
                    that.getGradeListBySchool(that.info.schoolId);
                }
            }
            that.show_type = e;
            that.show_shardow = true;
        },
        close() {
            let that = this;
            that.show_shardow = false;
            that.show_delete = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCurrentChange(val) {
            let that = this;
            that.pageNumber = val;
            that.ajaxload();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../userManagement/userManagement.css");


.show_detail {
    height: 344rem;
}

.shardow_title {
    width: 120rem;
}

.img_box {
    width: 220rem;
    height: 46rem;
    background-color: #f2f2f2;
    text-align: center;
    flex-direction: column;
}

.sons_img {
    width: 100%;
    height: 100%;
}

.img62 {
    width: 18rem;
    height: 14rem;
}

.img_banner {
    width: 40rem;
    height: 30rem;
}

.img_level {
    width: 80rem;
    height: 20rem;
}
</style>


// WEBPACK FOOTER //
// src/view/orderManagement/orderManagement.vue